export default {
  andUp: '& Up',
};



// WEBPACK FOOTER //
// ./~/instantsearch.js/src/widgets/star-rating/defaultLabels.js